<div class="search-bar-layout animated fadeIn">
    <div class="searchbar-mobile-topbar d-lg-none">
        <button type="button" class="searchbar-cancel" (click)="cancelMobile()"
                aria-label="Cancel search">Cancel</button>
    </div>
    <div class="search-wrap">
        <form class="searchbar-form" role="search" (ngSubmit)="onSearchSubmit()">
            <div class="searchbar-container">
                <span class="material-symbols-outlined searchbar-icon-leading" aria-hidden="true">search</span>

                <input #searchInput
                    class="searchbar-input"
                    type="search"
                    name="q"
                    placeholder="Search products"
                    aria-label="Search products"
                    role="combobox"
                    aria-autocomplete="list"
                    aria-controls="search-listbox"
                    [attr.aria-expanded]="showDropdown()"
                    [attr.aria-activedescendant]="selectedIndex >= 0 ? 'search-option-' + selectedIndex : null"
                    inputmode="search"
                    enterkeyhint="search"
                    autocomplete="off"
                    autocorrect="off"
                    autocapitalize="off"
                    spellcheck="false"
                    (keydown)="onInputKeydown($event)"
                    [(ngModel)]="searchBarContent"
                    (input)="inputSearchTypeHandler($event)"
                    (focus)="onSearchFocus()"
                    (blur)="onSearchBlur($event)" />

                <div class="searchbar-actions">
                    @if (isLoadingSuggestions()) {
                        <span class="spinner-border spinner-border-sm searchbar-inline-spinner" role="status" aria-label="Loading suggestions"></span>
                    } @else if (searchBarContent()) {
                        <button type="button" class="searchbar-btn searchbar-btn--clear"
                            (mousedown)="$event.preventDefault(); clearSearchInput()"
                            aria-label="Clear search">
                            <span class="material-symbols-outlined" aria-hidden="true">close</span>
                        </button>
                    }
                    <span class="searchbar-divider" aria-hidden="true"></span>
                    <button type="submit" class="searchbar-btn searchbar-btn--search"
                        aria-label="Search">
                        <span class="material-symbols-outlined" aria-hidden="true">search</span>
                    </button>
                </div>
            </div>
        </form>

        <!-- Autocomplete Dropdown -->
        @if (showDropdown()) {
            @let nav = flatNavItems();
            @let cold = isLoadingPopular() && nav.products.length === 0 && nav.leftItems.length === 0;

            <div id="search-listbox" role="listbox" class="autocomplete-dropdown position-absolute w-100 bg-white mt-1">

                @if (cold) {
                    <!-- First-load shimmer for popular content -->
                    <div class="autocomplete-loading py-4 text-center text-muted">
                        <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                        Loading…
                    </div>
                } @else {

                <div class="autocomplete-content d-flex" [class.is-loading]="isLoadingSuggestions()">
                    <!-- Left Column: Suggestions / Recents / Popular -->
                    <div class="autocomplete-suggestions">
                        @if (isQuerying()) {
                            <!-- Search-all sits at the top so Enter and ↓+Enter both feel natural -->
                            @let searchAllIdx = nav.leftItems.length - 1;
                            @if (querySuggestions().length > 0) {
                                <div class="suggestions-header">Suggestions</div>
                                @for (suggestion of querySuggestions(); track suggestion; let i = $index) {
                                    <div class="suggestion-item"
                                         role="option"
                                         [id]="'search-option-' + i"
                                         [class.active]="selectedIndex === i"
                                         [attr.aria-selected]="selectedIndex === i"
                                         (mouseenter)="onItemHover(i)"
                                         (mousedown)="$event.preventDefault(); onQuerySuggestionClick(suggestion)">
                                        <span class="material-symbols-outlined suggestion-icon" aria-hidden="true">search</span>
                                        <span class="suggestion-text">{{ suggestion }}</span>
                                    </div>
                                }
                            }

                            <div class="suggestion-item suggestion-item--search-all"
                                 role="option"
                                 [id]="'search-option-' + searchAllIdx"
                                 [class.active]="selectedIndex === searchAllIdx"
                                 [attr.aria-selected]="selectedIndex === searchAllIdx"
                                 (mouseenter)="onItemHover(searchAllIdx)"
                                 (mousedown)="$event.preventDefault(); navigateToSearch(searchBarContent())">
                                <span class="material-symbols-outlined suggestion-icon" aria-hidden="true">arrow_forward</span>
                                <span class="suggestion-text">
                                    Search all for "<strong>{{ searchBarContent() }}</strong>"
                                </span>
                            </div>
                        } @else {
                            @if (recentSearches().length > 0) {
                                <div class="suggestions-header suggestions-header--with-action">
                                    <span>Recent</span>
                                    <button type="button" class="suggestions-header__action"
                                            (mousedown)="onClearRecent($event)">Clear</button>
                                </div>
                                @for (term of recentSearches(); track term; let i = $index) {
                                    <div class="suggestion-item suggestion-item--removable"
                                         role="option"
                                         [id]="'search-option-' + i"
                                         [class.active]="selectedIndex === i"
                                         [attr.aria-selected]="selectedIndex === i"
                                         (mouseenter)="onItemHover(i)"
                                         (mousedown)="$event.preventDefault(); navigateToSearch(term)">
                                        <span class="material-symbols-outlined suggestion-icon" aria-hidden="true">history</span>
                                        <span class="suggestion-text">{{ term }}</span>
                                        <button type="button" class="suggestion-item__remove"
                                                aria-label="Remove from recent searches"
                                                (mousedown)="onLeftItemRemove($event, term)">
                                            <span class="material-symbols-outlined" aria-hidden="true">close</span>
                                        </button>
                                    </div>
                                }
                            }

                            @if (popularSearches().length > 0) {
                                <div class="suggestions-header">Popular Searches</div>
                                @for (term of popularSearches(); track term; let i = $index) {
                                    @let popIdx = recentSearches().length + i;
                                    <div class="suggestion-item"
                                         role="option"
                                         [id]="'search-option-' + popIdx"
                                         [class.active]="selectedIndex === popIdx"
                                         [attr.aria-selected]="selectedIndex === popIdx"
                                         (mouseenter)="onItemHover(popIdx)"
                                         (mousedown)="$event.preventDefault(); navigateToSearch(term)">
                                        <span class="material-symbols-outlined suggestion-icon" aria-hidden="true">trending_up</span>
                                        <span class="suggestion-text">{{ term }}</span>
                                    </div>
                                }
                            }
                        }
                    </div>

                    <!-- Right Column: Product Cards Grid -->
                    <div class="autocomplete-products">
                        <div class="products-header">
                            {{ productsHeaderText() }}
                            @if (nav.products.length > 0) {
                                <span class="products-count">({{ nav.products.length }})</span>
                            }
                        </div>

                        @if (nav.products.length > 0) {
                            <div class="products-grid">
                                @for (product of nav.products; track product.id; let i = $index) {
                                    @let productIdx = nav.leftItems.length + i;
                                    <app-autocomplete-product-card
                                        role="option"
                                        [id]="'search-option-' + productIdx"
                                        [attr.aria-selected]="selectedIndex === productIdx"
                                        [product]="product"
                                        [isLoading]="addingToCartProductId() === product.id"
                                        [hasSession]="hasSession()"
                                        [active]="selectedIndex === productIdx"
                                        (mouseenter)="onItemHover(productIdx)"
                                        (productClick)="onProductCardClick($event)"
                                        (addToCartClick)="onProductAddToCart($event)">
                                    </app-autocomplete-product-card>
                                }

                                @if (nav.hasSearchAllCard) {
                                    <!-- Trailing tile: the grid only shows the first page of matches, so this
                                         is where the count of everything else lives. Same action as the left
                                         column's "Search all" row. -->
                                    @let searchAllCardIdx = nav.leftItems.length + nav.products.length;
                                    <button type="button"
                                            class="search-all-card"
                                            role="option"
                                            [id]="'search-option-' + searchAllCardIdx"
                                            [attr.aria-selected]="selectedIndex === searchAllCardIdx"
                                            [class.is-active]="selectedIndex === searchAllCardIdx"
                                            (mouseenter)="onItemHover(searchAllCardIdx)"
                                            (mousedown)="$event.preventDefault(); navigateToSearch(searchBarContent())">
                                        <span class="search-all-card__text">
                                            Search all {{ suggestionsTotalFound() }} products for
                                            "<strong>{{ searchBarContent() }}</strong>"
                                        </span>
                                        <span class="material-symbols-outlined search-all-card__icon" aria-hidden="true">arrow_forward</span>
                                    </button>
                                }
                            </div>
                        } @else if (!isLoadingSuggestions()) {
                            <div class="products-empty py-4 text-center text-muted">
                                <span class="material-symbols-outlined mb-2" aria-hidden="true" style="font-size: 24px;">inventory_2</span>
                                <p class="mb-0">No products found</p>
                                @if (isQuerying()) {
                                    <button type="button" class="btn btn-link btn-sm"
                                            (mousedown)="$event.preventDefault(); navigateToSearch(searchBarContent())">
                                        Try "Search all" instead
                                    </button>
                                }
                            </div>
                        }
                    </div>
                </div>
                }
            </div>
        }
    </div>
</div>
